import React, { useEffect } from 'react';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';
import { useProductSizes } from '../../../hooks/product/useProductSizes';
import { IProductSizeFormValues } from '../../../types/product/productSizeInterfaces';

interface ProductSizePopupProps {
  isOpen: boolean;
  close: () => void;
  onSubmit: (data: IProductSizeFormValues) => void;
}

const ProductSizePopup: React.FC<ProductSizePopupProps> = ({
  isOpen,
  close,
  onSubmit,
}) => {
  const {
    form,
    formErrors,
    isSubmit,
    updateField,
    saveFormErrors,
    clearErrors,
  } = useProductSizes();

  const validate = () => {
    const errors: Record<string, string> = {};

    if (!form.code.trim()) {
      errors.code = 'El código de la talla es obligatorio';
    } else if (form.code.trim().length < 1) {
      errors.code = 'Debe tener al menos 1 caracter';
    }

    if (!form.name.trim()) {
      errors.name = 'El nombre de la talla es obligatorio';
    }

    saveFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (!isOpen) clearErrors();
  }, [isOpen]);

  const handleSubmit = () => {
    clearErrors();
    if (validate()) {
      onSubmit(form);
    }
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={close}
      title={form.id === 0 ? 'Agregar Talla' : 'Editar Talla'}
      maxWidth="max-w-md"
    >
      <div className="mt-4 flex flex-col gap-4">
        <InputField
          label="Código"
          name="code"
          placeholder="Ej: XS, ONE, 3XL"
          type="text"
          value={form.code}
          onChange={(e) => updateField('code', e.target.value)}
          error={formErrors.code}
          iconKey="tag"
        />

        <InputField
          label="Nombre"
          name="name"
          type="text"
          placeholder="Nombre descriptivo"
          value={form.name}
          onChange={(e) => updateField('name', e.target.value)}
          error={formErrors.name}
          iconKey="edit"
        />

        <button
          onClick={handleSubmit}
          disabled={isSubmit}
          className={`w-full rounded bg-primary px-4 py-2 font-medium text-white
            transition hover:bg-opacity-90 
            ${isSubmit ? 'cursor-not-allowed opacity-50' : ''}`}
        >
          {form.id === 0 ? 'Registrar Talla' : 'Actualizar Talla'}
        </button>
      </div>
    </FormModal>
  );
};

export default ProductSizePopup;
